(function(){
'use strict';
function R(m){
  try{if(window.Sentry)Sentry.captureException(new Error('[jqfix] '+m));}catch(_){}
  console.warn('[jqfix]',m);
}
if(!window.rimg){window.rimg={shopify:{init:function(){}}};R('rimg missing');}
else if(!window.rimg.shopify){window.rimg.shopify={init:function(){}};}
if(typeof window.ShopifySectionsManager!=='function'){
  function SSM(){}SSM.prototype.register=function(){};
  window.ShopifySectionsManager=SSM;R('ShopifySectionsManager missing');
}
if(!window.AgeGate){
  window.AgeGate={PageAgeGate:function(){},SiteAgeGate:function(){}};R('AgeGate missing');
}else{
  if(typeof window.AgeGate.PageAgeGate!=='function')window.AgeGate.PageAgeGate=function(){};
  if(typeof window.AgeGate.SiteAgeGate!=='function')window.AgeGate.SiteAgeGate=function(){};
}
if(!window.Flickity){
  function FS(){}FS.prototype._create=function(){};
  Object.defineProperty(window,'Flickity',{configurable:true,enumerable:true,
    get:function(){return FS;},
    set:function(V){Object.defineProperty(window,'Flickity',{configurable:true,writable:true,enumerable:true,value:V});R('Flickity loaded late');}
  });
  R('Flickity missing');
}
function gFB(){
  var jq=window.jQuery||window.$;
  if(!jq||jq.__g||jq.fancybox)return;
  jq.fancybox={defaults:{},open:function(){},close:function(){}};R('$.fancybox missing');
}
gFB();
(function(){
  if(window.jQuery&&!window.jQuery.__g)return;
  var q=[],s={length:0,offset:function(){return{top:0,left:0};},scrollTop:function(v){return v===undefined?0:s;}};
  function shim(f){if(typeof f==='function')q.push(f);return s;}
  shim.__g=1;
  if(!window.$||window.$.__g)window.$=shim;
  if(!window.jQuery||window.jQuery.__g)window.jQuery=shim;
  var n=0,iv=setInterval(function(){
    var jq=window.jQuery;
    if(jq&&!jq.__g){clearInterval(iv);for(var i=0;i<q.length;i++)try{jq(q[i]);}catch(e){R(e.message);}gFB();}
    else if(++n>100){clearInterval(iv);R('jQuery never loaded ('+q.length+' queued)');}
  },50);
  R('jQuery missing — shim active');
}());
window.__safeOffsetTop=function(sel){
  try{var jq=window.jQuery;if(!jq||jq.__g)return 0;var e=jq(sel);if(!e||!e.length)return 0;var o=e.offset();return(o&&+o.top===o.top)?o.top:0;}
  catch(e){R(e.message);return 0;}
};
window.addEventListener('error',function(ev){
  var m=(ev&&ev.message)||'';
  if(/flickity|fancybox|\$ is not|jquery|scrolltop|\.offset|sectionsmanager|agegate|rimg/i.test(m))
    R(m+' ['+ev.filename+':'+ev.lineno+']');
},true);
}());
